//
//
//
//

export default {
  name: 'Lottie',
  props: {
    loadAnimation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '400px',
      threshold: 1.0,
    }
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.anim()
      }
    }, options)
    this.observer.observe(this.$el)
  },
  destroyed() {
    this.observer.disconnect()
  },
  methods: {
    async anim() {
      const lottie = await import('lottie-web')
      if (!this.$el.classList.contains('loaded')) {
        const json = await import(
          `@/assets/animation${this.loadAnimation.animationData}`
        )
        if (this.loadAnimation.container) {
          const element = this.$el
          lottie.loadAnimation({
            ...this.loadAnimation,
            container: element,
            animationData: json,
          })
        }
        this.$el.classList.add('loaded')
      }
    },
  },
}
